import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.object.assign";
import _defineProperty from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.function.name";

var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import config from '@/config';
import { pests } from '@/api/api_url';
import { getToken, formatYMD } from '@/libs/util';
import { renderFormMixins } from '@/mixins/renderFormMixins';
import { project_list, building_list } from '@/api/pests';
export default {
  name: "addAppCustom",
  mixins: [renderFormMixins],
  data: function data() {
    return {
      defaultList: [],
      projectList: [],
      buildingList: [],
      //建筑物列表
      center: {
        lng: 0,
        lat: 0
      },
      zoom: 3,
      BMap: null,
      position: {
        lng: 0,
        lat: 0
      },
      uploadList: [],
      refName: 'refName',
      headers: {
        Authorization: getToken()
      },
      hasDisabled: true,
      fileName: 'image',
      fileData: {
        client_id: ""
      },
      format: ['jpg', 'jpeg', 'png'],
      visible: false,
      imgName: '',
      uploadData: {
        client_id: null
      },
      uploadHeaders: {
        "Authorization": getToken()
      },
      proAttrFile: {},
      formModel: {
        project_code: null,
        //项目编码
        building_code: null,
        //建筑物编码
        floor_num: null,
        //所在楼层
        floor_file: null //平面图路径

      },
      formRules: {
        project_code: [{
          required: true,
          message: '项目名称不能为空',
          trigger: 'change'
        }],
        building_code: [{
          required: true,
          message: '建筑物不能为空',
          trigger: 'change'
        }],
        floor_num: [{
          required: true,
          type: 'number',
          message: '所在楼层不能为空',
          trigger: 'change'
        }],
        floor_file: [{
          required: true,
          message: '平面图不能为空',
          trigger: 'change'
        }]
      }
    };
  },
  props: {
    _vm: {},
    edit: {},
    $store: {},
    setData: {}
  },
  components: {},
  computed: {
    getAction: function getAction() {
      var result = '';

      if (process.env.NODE_ENV === 'development') {
        result = config.baseUrl.dev + "" + pests.upload_file;
      } else if (process.env.VUE_APP_BUILD === 'production') {
        result = config.baseUrl.pro + "" + pests.upload_file;
      } else {
        result = config.baseUrl.alp + "" + pests.upload_file;
      }

      return result;
    }
  },
  methods: (_methods = {
    /**
     * 项目change
     */
    projectChange: function projectChange(val, callback) {
      var _this2 = this;

      this.$set(this.formModel, 'building_code', null);
      building_list({
        page: 0,
        page_size: 15,
        project_code: val
      }).then(function (res) {
        if (res.result === 0) {
          _this2.buildingList = res.body.list || [];

          if (callback) {
            callback();
          }
        }
      });
    },
    handleView: function handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    handleRemove: function handleRemove(file) {
      var fileList = this.$refs.upload.fileList;
      this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
    },
    handleMaxSize: function handleMaxSize(file) {
      this.$Notice.warning({
        title: '文件大小超出限制',
        desc: '请上传小于4M的图片'
      });
    },
    handleBeforeUpload: function handleBeforeUpload() {
      return true;
    },

    /**
     * 维保开始日期
     */
    startChange: function startChange(val) {
      this.$set(this.formModel, 'maintain_start', val);
    },

    /**
     * 合同开始日期
     */
    contractTimeChange: function contractTimeChange(arr) {
      this.$set(this.formModel, 'contract_start', arr[0]);
      this.$set(this.formModel, 'contract_end', arr[1]);
    },
    handler: function handler(_ref) {
      var BMap = _ref.BMap,
          map = _ref.map;
      this.zoom = 12;

      var _this = this;

      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(function (r) {
        _this.center = {
          lng: r.longitude,
          lat: r.latitude
        };

        _this.$set(_this.center, 'lng', r.longitude);

        _this.$set(_this.center, 'lat', r.latitude);

        _this.initLocation = true;
      });
      _this.BMap = BMap;
    },

    /**
     * 根据点位获取地理位置
     */
    getLocationAddr: function getLocationAddr(point) {
      var _this = this;

      var gc = new this.BMap.Geocoder();
      gc.getLocation(point, function (rs) {
        console.log(rs);

        if (rs) {
          _this.$set(_this.formModel, 'address', rs.address);
        }
      });
    },
    getLatLng: function getLatLng(point) {
      this.$set(this.formModel, 'lat', point.lat);
      this.$set(this.formModel, 'lng', point.lng);
      this.$set(this.formModel, 'center', point.lng + ',' + point.lat);
    },

    /**
     * 地图点击事件
     */
    mapClick: function mapClick(_ref2) {
      var type = _ref2.type,
          target = _ref2.target,
          point = _ref2.point,
          pixel = _ref2.pixel,
          overlay = _ref2.overlay;
      console.log({
        type: type,
        target: target,
        point: point,
        pixel: pixel,
        overlay: overlay
      });
      this.$set(this, 'position', point);
      console.log(this.position);
      this.getLocationAddr(this.position);
      this.getLatLng(point);
    },
    //检查图片的width和height
    checkImageWH: function checkImageWH(file, width, height) {
      var self = this._vm;
      return new Promise(function (resolve, reject) {
        var filereader = new FileReader();

        filereader.onload = function (e) {
          var src = e.target.result;
          var image = new Image();

          image.onload = function () {
            if (width && this.width != width) {
              self.$Notice.error({
                title: self.$t('operationModule.uploadFileFormatTitleWidth') + width
              });
              reject();
              self.spinShow = false;
            } else if (height && this.height != height) {
              self.$Notice.error({
                title: self.$t('operationModule.uploadFileFormatTitleHeight') + height
              });
              reject();
              self.spinShow = false;
            } else {
              resolve();
            }
          };

          image.onerror = reject;
          image.src = src;
        };

        filereader.readAsDataURL(file);
      });
    },

    /**
     * 上传之前检查width,height
     */
    handleUploadImg: function handleUploadImg(file, width, height) {
      return this.checkImageWH(file, width, height);
    }
  }, _defineProperty(_methods, "handleRemove", function handleRemove(file, fileList, str) {
    this.$set(this.formModel, 'company_avatar', '');
    this.uploadList.splice(0);
  }), _defineProperty(_methods, "handleSuccess", function handleSuccess(res, file, str) {
    var vm = this;
    this.uploadList.splice(0);

    if (res.result === 0) {
      //to do
      this.$set(this.formModel, 'floor_file', res.body.file_path);
      this.uploadList.push({
        status: 'finished',
        url: res.body.file_path,
        name: file.name
      });
    } else {
      //删除上传的对象
      this.$Message.error(res.errorMsg);
    }
  }), _defineProperty(_methods, "handleView", function handleView(name) {
    this.imgName = name;
    this.visible = true;
  }), _defineProperty(_methods, "handleFormatError", function handleFormatError(file) {
    this.$Notice.warning({
      title: '文件格式错误',
      desc: '请上传' + this.format.join(', ') + '类型文件'
    });
  }), _defineProperty(_methods, "init", function init() {
    var _this3 = this;

    project_list({
      page: 0,
      page_size: 15
    }).then(function (res) {
      if (res.result === 0) {
        _this3.projectList = res.body.list || [];
      }
    });
  }), _defineProperty(_methods, "handleUpload", function handleUpload(file, data) {
    return true;
  }), _methods),
  mounted: function mounted() {
    var _this4 = this;

    if (this.edit) {
      if (this.setData) {
        Object.assign(this.formModel, this.setData);
        this.$set(this.formModel, 'floor_num', Number(this.setData.floor_num));
        this.uploadList.push({
          status: 'finished',
          url: this.setData.floor_file,
          name: this.setData.floor_file
        });
        this.projectChange(this.formModel.project_code, function () {
          _this4.$set(_this4.formModel, 'building_code', _this4.setData.building_code);
        });
      }
    }
  },
  created: function created() {
    this.init();
  }
};